module.exports = __webpack_public_path__ + "img/happytable_product1.8e1167a6.jpg";